import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ClientPage } from '../../../features/clients/ui/client-panel.tsx';
import { requirePermissionRoute } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/clients/$id')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: ClientRoute,
});

/** Клиент на всю страницу (⌘↵ из панели). */
function ClientRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    <ClientPage
      id={id}
      onBack={() => {
        void navigate({ to: '/clients', search: { client: id } });
      }}
      onDeleted={() => {
        void navigate({ to: '/clients', search: {} });
      }}
    />
  );
}
